// extracted by mini-css-extract-plugin
export default {"addNewTopic":"ForumArea_addNewTopic__aDzjV","text":"ForumArea_text__Ct9Bw","addIcon":"ForumArea_addIcon__tLpbM"};